<template>
  <b-card>
    <b-card-body>
      <div class="overflow-x-auto">
        <div class="filter_Documentacion">
          <PSidebar
            v-model="mostrarFiltros"
            :title="$t('label.filtros')"
            icon="IconFilter"
            bVariant="secondary"
            :textButton="dameTextoBotonFiltros"
          >
            <documentacion-importacion-table-filters
              v-model="filtersDocumentos"
              actionName="filtrar"
              :textActionName="$t('label.filtrar')"
              :maxRangeMonth="0"
              @action="action"
              @cancel="action"
            />
          </PSidebar>
        </div>
        <QuickFilter
          :params.sync="params"
          @change="onChangeQuickFilter"
          :showOptionTodos="true"
          :documentType="'ByImportacion'"
        />
        <div class="table-responsive">
          <hr />

          <b-table
            ref="tableDocumentos"
            :fields="visibleFields"
            :items="items"
            :sort-by.sync="params.orderBy"
            :sort-desc.sync="sortDesc"
            :empty-text="$t('label.noData')"
            no-border-collapse
            show-empty
            sort-icon-left
            @sort-changed="onSortingChange"
            responsive
            no-local-sorting
            borderless
          >
            <div class="text-center loader my-2" slot="table-busy">
              <b-spinner class="align-middle" />
            </div>
            <template #head(add-columns)>
              <select-columns :fields.sync="fields" :pagination="params" :cod-table="codTable" />
            </template>
            <template #cell(actions-left)="row">
              <div class="table-button-container">
                <button
                  v-if="!hasAnyValidationError(row.item) && isApprovalPending(row.item)"
                  :id="`checkFile-${row.index}`"
                  class="ml-1 my-auto"
                  @click="approve(row.item)"
                >
                  <b-icon icon="check-lg" class="check-icon" style="color: black" />
                </button>
                <button
                  :id="`downloadFile-${row.index}`"
                  class="ml-1 my-auto"
                  @click="download(row.item)"
                >
                  <icon-download :height="16" :width="16" color="#000" />
                </button>
                <button
                  :id="`removeFile-${row.index}`"
                  class="ml-1 my-auto"
                  @click="remove(row.item)"
                >
                  <icon-trash :size="16" color="#000" />
                </button>
                <span
                  v-if="hasAnyValidationError(row.item)"
                  :id="`warningFile-${row.index}`"
                  v-b-tooltip.right.d300="extractErrorMessage(row.item)"
                  class="ml-1 my-auto"
                >
                  <icon-warning :width="16" :height="16" color="#000" />
                </span>
              </div>
            </template>
          </b-table>
        </div>
        <div
          class="mt-3"
          v-if="documentacionResponse && documentacionResponse.totalElements > params.size"
        >
          <pagination
            :current-page="params.page"
            :page-size="params.size"
            :total-elements="documentacionResponse.totalElements"
            @change="onChangeCurrentPage"
          />
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import {
  ICliente,
  IDelegacion,
  IDocumentoByImportacionTableItem,
  IField,
  ISoConfColumnasUpdateDTO,
  IUsuario,
} from "@/entities";
import { Action, Getter } from "vuex-class";
import VueFilters from "@/vue-filters";
import SelectColumns from "@/components/common/SelectColumns/SelectColumns.vue";
import QuickFilter from "@/components/documentacion/common/QuickFilter.vue";
import { EventBus } from "@/event-bus";

import {
  EDirection,
  IColumnaResponse,
  IDocumentacionImportacionFilters,
  IDocumentacionImportacionParams,
  IDocumentacionImportacionResponse,
} from "@/services";
import { IconDownload, IconTrash } from "@/components/look";
import VueMethods from "@/vue-methods";
import { Dictionary } from "vue-router/types/router";
import DocumentacionImportacionTableFilters from "@/components/documentacion/DocumentacionImportacionTableFilters.vue";
import { SweetAlertResult } from "sweetalert2";
import Pagination from "@/components/common/Pagination.vue";

@Component({
  components: {
    Pagination,
    IconTrash,
    DocumentacionImportacionTableFilters,
    IconDownload,
    SelectColumns,
    QuickFilter,
  },
  mixins: [VueFilters, VueMethods],
})
export default class DocumentosImportacionTable extends Vue {
  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Getter("getDelegacionesCliente") delegations!: IDelegacion[];
  @Action("saveColumna") saveColumna!: (
    params: ISoConfColumnasUpdateDTO
  ) => Promise<IColumnaResponse | undefined>;

  @Prop({ required: false, default: {} })
  fieldsI!: IField[];

  @Prop({ required: true })
  params!: IDocumentacionImportacionParams;

  public codTable = "documentosImportados";
  private ERROR = "ERROR";
  private PENDIENTE = "PENDIENTE";
  private PENDIENTE_APROBACION = "PENDIENTE_APROBACION";
  private PROCESADO = "PROCESADO";

  public filtersDocumentos: IDocumentacionImportacionFilters = {
    documentTitle: "",
    documentType: "",
    delegationsSelected: [],
    fechaArchivoInicio: "",
    fechaArchivoFin: "",
    fechaSubidaInicio: "",
    fechaSubidaFin: "",
    usuario: "",
    estado: "",
    aprobadoPor: "",
  };

  public mostrarFiltros = false;
  private documentacionResponse?: IDocumentacionImportacionResponse | null = null;
  private documentacionResponseList?: IDocumentoByImportacionTableItem[] = [];
  public sortDesc = true;

  created(): void {
    this.filtersDocumentos = {
      documentTitle: this.params.documentTitle ?? "",
      documentType: this.params.documentType ?? "",
      delegationsSelected: this.params.delegaciones || [],
      fechaArchivoInicio: this.params.fechaArchivoInicio ?? "",
      fechaArchivoFin: this.params.fechaArchivoFin ?? "",
      fechaSubidaInicio: this.params.fechaSubidaInicio ?? "",
      fechaSubidaFin: this.params.fechaSubidaFin ?? "",
      usuario: this.params.usuario ?? "",
      estado: this.params.estado ?? "",
      aprobadoPor: this.params.aprobadoPor ?? "",
    };
    this.sortDesc = this.params.direction === EDirection.DESC;
  }

  async mounted(): Promise<void> {
    EventBus.$on("update-documentos-importacion-table", () => {
      this.getDocumentos();
    });
  }

  async loadInfo(): Promise<void> {
    const delegacionsSelected = this.delegations?.filter((d) =>
      this.params.delegaciones?.find((code) => code === d.codDelegacionSol)
    );

    this.params.delegaciones = delegacionsSelected.map((d) => d.codDelegacionSol);
    this.filtersDocumentos.delegationsSelected = delegacionsSelected.map((d) => d.codDelegacionSol);

    await this.getDocumentos();
  }

  get items(): IDocumentoByImportacionTableItem[] {
    return this.documentacionResponseList || [];
  }

  async onChangeQuickFilter(): Promise<void> {
    await this.loadInfo();
  }

  public get visibleFields(): IField[] {
    return this.fieldsI.filter((item) => item.visible);
  }

  get fields(): IField[] {
    return JSON.parse(JSON.stringify(this.fieldsI));
  }

  set fields(fields: IField[]) {
    this.$emit("update:fieldsI", fields);
  }

  get dameTextoBotonFiltros(): string {
    let numFiltros = 0;
    Object.keys(this.filtersDocumentos).forEach((key: string) => {
      if (
        (this.filtersDocumentos as any)[key] != "" &&
        (this.filtersDocumentos as any)[key] != null
      ) {
        numFiltros = numFiltros + 1;
      }
    });

    return numFiltros
      ? `(${numFiltros}) ${this.$t("label.filtros")}`
      : this.$t("label.filtros").toString();
  }

  onChangeCurrentPage(currentPage: number): void {
    this.params.page = currentPage;
    this.getDocumentacion();
  }

  onSortingChange(sort: { sortBy: string; sortDesc: boolean }): void {
    this.$nextTick(async () => {
      this.params.direction = sort.sortDesc ? EDirection.DESC : EDirection.ASC;
      await this.getDocumentacion();
      await this.saveColumnsConfig();
    });
  }

  async saveColumnsConfig(): Promise<void> {
    const params: ISoConfColumnasUpdateDTO = {
      codColumna: this.visibleFields
        .filter((f) => !f.aux)
        .map((f) => f.code)
        .toString(),
      codTabla: this.codTable,
      codTipoOrden: this.params.direction,
      numPagElements: this.params.size,
      codOrden: this.params.orderBy,
    };

    await this.saveColumna(params);
  }

  async getDocumentacion(): Promise<void> {
    this.params.pkCliente = this.getClienteSelected?.id?.toString();

    this.$nextTick(() => {
      this.$router
        .replace({ path: this.$route.path, query: { ...this.params } as Dictionary<any> })
        .catch(() => {
          // Do nothing
        });
    });

    const params = JSON.parse(JSON.stringify(this.params)) as IDocumentacionImportacionParams;
    params.page = params.page ? params.page - 1 : 0;

    this.documentacionResponse = await this.$services.documentacion._fetchImportacion(params);
    this.documentacionResponseList = [];
    this.documentacionResponse?.content.forEach((documentacion) => {
      this.documentacionResponseList?.push({
        id: documentacion.id,
        documentTitle: documentacion.documentTitle,
        documentType: documentacion?.documentType,
        codCliente: documentacion.cliente?.codCliente.toString(),
        cliente: documentacion.cliente?.desCliente,
        codDelegacion: documentacion.delegacion?.codDelegacionSol,
        delegacion: documentacion.delegacion?.desDelegacion,
        fechaArchivo: documentacion.fechaArchivo,
        fechaSubida: documentacion.fechaSubida,
        usuario: documentacion.usuario?.codUsuario.toString(),
        message: documentacion.message,
        estado: this.estadoDescripcion(documentacion.estado),
        mensajeEstado: documentacion.mensajeEstado,
        aprobadoPor: this.aprobadoPorDescripcion(
          documentacion.estado,
          documentacion.usuarioAprobador
        ),
      });
    });
  }

  async download(doc: IDocumentoByImportacionTableItem): Promise<void> {
    const response = await this.$services.documentacion.downloadFileOfImportation(doc);

    if (response) {
      this.downloadFile(response);
    } else {
      this.makeToast("danger", this.$t("label.documentation.download.error").toString());
    }
  }

  async remove(doc: IDocumentoByImportacionTableItem): Promise<void> {
    const { isConfirmed } = await this.modalConfirmDeleteDocument();
    if (isConfirmed) {
      await this.$services.documentacion.removeImported(doc);
      await this.getDocumentacion();
      this.makeToast("success", this.$t("document.removed").toString());
    }
  }

  async approve(doc: IDocumentoByImportacionTableItem): Promise<void> {
    const { isConfirmed } = await this.modalConfirmApproveDocument();
    if (isConfirmed) {
      await this.$services.documentacion.approveImported(doc);
      await this.getDocumentacion();
      this.makeToast("success", this.$t("document.approved").toString());
    }
  }

  action(action: { action: string }): void {
    if (action.action === "filtrar" || action.action === "clean") {
      this.params.fechaArchivoInicio = this.getStartDate(this.filtersDocumentos.fechaArchivoInicio);
      this.params.fechaArchivoFin = this.getEndDate(this.filtersDocumentos.fechaArchivoFin);
      this.params.fechaSubidaInicio = this.getStartDate(this.filtersDocumentos.fechaSubidaInicio);
      this.params.fechaSubidaFin = this.getEndDate(this.filtersDocumentos.fechaSubidaFin);
      this.params.delegaciones = this.filtersDocumentos.delegationsSelected;
      this.params.documentType = this.filtersDocumentos.documentType ?? undefined;
      this.params.documentTitle = this.filtersDocumentos.documentTitle ?? undefined;
      this.params.usuario = this.filtersDocumentos.usuario ?? undefined;
      this.params.estado = this.filtersDocumentos.estado ?? undefined;
      this.params.aprobadoPor = this.filtersDocumentos.aprobadoPor ?? undefined;

      this.mostrarFiltros = false;
      this.getDocumentos();
    }
  }

  async modalConfirmDeleteDocument(): Promise<SweetAlertResult> {
    return this.$swal({
      title: this.$t("label.documentation.deletion"),
      text: this.$t("label.documentation.deletion.confirmation.message"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.$t("label.yes"),
      cancelButtonText: this.$t("label.no"),
    });
  }

  private async modalConfirmApproveDocument() {
    return this.$swal({
      title: this.$t("label.documentation.approval"),
      text: this.$t("label.documentation.approval.confirmation.message"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.$t("label.yes"),
      cancelButtonText: this.$t("label.no"),
    });
  }

  async getDocumentos(): Promise<void> {
    this.params.page = 1;
    await this.getDocumentacion();
  }

  hasAnyValidationError(item: IDocumentoByImportacionTableItem): boolean {
    return item.estado.toUpperCase() === this.ERROR;
  }

  isApprovalPending(item: IDocumentoByImportacionTableItem): boolean {
    return item.estado === this.$t("label.estado.documento.pendiente-aprobacion");
  }

  extractErrorMessage(item: IDocumentoByImportacionTableItem): string {
    if (item.mensajeEstado) {
      const toLowerCase = item.mensajeEstado.toLowerCase();
      const key = `file.validationError.${toLowerCase}`;
      return this.$te(key, this.$i18n.fallbackLocale.toString())
        ? this.$t(key)
        : item.mensajeEstado;
    }
    return "";
  }
  private estadoDescripcion(estado: string): string {
    let res = estado;
    if (estado == this.PENDIENTE) {
      res = this.$t("label.estado.documento.pendiente");
    } else if (estado == this.PENDIENTE_APROBACION) {
      res = this.$t("label.estado.documento.pendiente-aprobacion");
    } else if (estado == this.PROCESADO) {
      res = this.$t("label.estado.documento.procesado");
    } else if (estado == this.ERROR) {
      res = this.$t("error");
    }
    return res;
  }

  private aprobadoPorDescripcion(estado: string, aprobadoPor?: IUsuario): string {
    if (![this.PENDIENTE, this.PROCESADO].includes(estado)) {
      return "";
    }
    return aprobadoPor?.codUsuario ?? this.$t("label.documento.aprobacion-automatica");
  }
}
</script>
<style lang="scss" scoped>
.descripcion-cliente {
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  color: var(--secundario-prosegur-claro);
}

.check-icon {
  color: green;
}

.icon {
  width: 30px;
  color: var(--amarillo-prosegur);
  padding-left: 3px;
}

.filter_Documentacion {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (min-width: 681px) {
    float: right;
  }
}

.material::v-deep .vs__dropdown-toggle {
  border: none;
  cursor: pointer;
}

.material::v-deep .vs__selected-options .vs__selected {
  padding-left: 0;
  margin-top: 0;
  margin-left: 0;
  font-size: 14px;
  color: #808080;
  font-weight: bold;
}

.disabled {
  pointer-events: none;
  cursor: initial;
  opacity: 0.4;
}

#input-cod-cliente-button {
  width: 150px;
  font-size: 12px;
  padding: 0;
  color: #979797;
  text-align: start;
}

#input-cod-cliente-icon {
  margin-left: 8px;
}

#input-cod-cliente {
  width: 150px;
}

.separator {
  width: 1px;
  height: 100%;
  border: solid 1px #e9e9e9;
}

#divisas-group {
  padding: 0 2em;
}

#input-divisas-label {
  font-size: 12px;
  line-height: 1.33;
  color: #979797;
}

#divisas-group > button {
  margin-right: 10px;
  width: 68px;
  height: 23px;
  object-fit: contain;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  padding-top: 0.15rem;
  padding-left: 16px;
  padding-right: 16px;
  color: var(--secundario-prosegur-oscuro);
  background-color: var(--fondo-not-active-toggle);
  border-color: var(--fondo-not-active-toggle);
}

#divisas-group > button.active {
  font-weight: 500;
  background-color: var(--amarillo-prosegur);
  border-color: var(--amarillo-prosegur);
}
</style>
